import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const Container = styled.div`
    width: 100%;
    font-size: ${theme.font.size8};
    background-color: #bcbebd;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    font-weight: bold;
    padding-left: 5px;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    letter-spacing: 1px;
`;
